import React, { useEffect, useRef } from "react";
import katex from "katex";

export const InlineMath = ({ math }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            try {
                katex.render(math, containerRef.current, {
                    displayMode: false,
                    throwOnError: false,
                });
            } catch (e) {
                console.error("KaTeX inline render error:", e);
                containerRef.current.textContent = math;
            }
        }
    }, [math]);

    return <span ref={containerRef} />;
};

export const BlockMath = ({ math }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            try {
                katex.render(math, containerRef.current, {
                    displayMode: true,
                    throwOnError: false,
                });
            } catch (e) {
                console.error("KaTeX block render error:", e);
                containerRef.current.textContent = math;
            }
        }
    }, [math]);

    return <div ref={containerRef} className="katex-display" />;
};
